import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  ConfirmarEscalaModel,
  ResumoValorMotoristaSearchModel,
} from '../../../models/escala-frota.model'

@Injectable({
  providedIn: 'root',
})
export class EscalaFrotaService {
  private baseUrl = environment.baseUrl
  private resource = 'EscalaFrota'

  constructor(private httpClient: HttpClient) {}

  public sugerir(osId: string): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/sugerir/${osId}`,
      {},
    )
  }

  public sugerirDia(
    data: string,
    estado?: string | null,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/sugerir-dia`,
      { data, estado: estado || undefined },
    )
  }

  public confirmar(
    model: ConfirmarEscalaModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/confirmar`,
      model,
    )
  }

  public resumoValorMotorista(
    model: Partial<ResumoValorMotoristaSearchModel>,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/resumo-valor-motorista`,
      model,
    )
  }
}
